"use client"; // src/tabs.tsx

import _objectSpread from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _objectWithoutProperties from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["__scopeTabs", "value", "onValueChange", "defaultValue", "orientation", "dir", "activationMode"],
    _excluded2 = ["__scopeTabs", "loop"],
    _excluded3 = ["__scopeTabs", "value", "disabled"],
    _excluded4 = ["__scopeTabs", "value", "forceMount", "children"];
import * as React from "react";
import { composeEventHandlers } from "@radix-ui/primitive";
import { createContextScope } from "@radix-ui/react-context";
import { createRovingFocusGroupScope } from "@radix-ui/react-roving-focus";
import { Presence } from "@radix-ui/react-presence";
import { Primitive } from "@radix-ui/react-primitive";
import * as RovingFocusGroup from "@radix-ui/react-roving-focus";
import { useDirection } from "@radix-ui/react-direction";
import { useControllableState } from "@radix-ui/react-use-controllable-state";
import { useId } from "@radix-ui/react-id";
import { jsx } from "react/jsx-runtime";
var TABS_NAME = "Tabs";

var _createContextScope = createContextScope(TABS_NAME, [createRovingFocusGroupScope]),
    _createContextScope2 = _slicedToArray(_createContextScope, 2),
    createTabsContext = _createContextScope2[0],
    createTabsScope = _createContextScope2[1];

var useRovingFocusGroupScope = createRovingFocusGroupScope();

var _createTabsContext = createTabsContext(TABS_NAME),
    _createTabsContext2 = _slicedToArray(_createTabsContext, 2),
    TabsProvider = _createTabsContext2[0],
    useTabsContext = _createTabsContext2[1];

var Tabs = React.forwardRef(function (props, forwardedRef) {
  var __scopeTabs = props.__scopeTabs,
      valueProp = props.value,
      onValueChange = props.onValueChange,
      defaultValue = props.defaultValue,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? "horizontal" : _props$orientation,
      dir = props.dir,
      _props$activationMode = props.activationMode,
      activationMode = _props$activationMode === void 0 ? "automatic" : _props$activationMode,
      tabsProps = _objectWithoutProperties(props, _excluded);

  var direction = useDirection(dir);

  var _useControllableState = useControllableState({
    prop: valueProp,
    onChange: onValueChange,
    defaultProp: defaultValue !== null && defaultValue !== void 0 ? defaultValue : "",
    caller: TABS_NAME
  }),
      _useControllableState2 = _slicedToArray(_useControllableState, 2),
      value = _useControllableState2[0],
      setValue = _useControllableState2[1];

  return /* @__PURE__ */jsx(TabsProvider, {
    scope: __scopeTabs,
    baseId: useId(),
    value: value,
    onValueChange: setValue,
    orientation: orientation,
    dir: direction,
    activationMode: activationMode,
    children: /* @__PURE__ */jsx(Primitive.div, _objectSpread(_objectSpread({
      dir: direction,
      "data-orientation": orientation
    }, tabsProps), {}, {
      ref: forwardedRef
    }))
  });
});
Tabs.displayName = TABS_NAME;
var TAB_LIST_NAME = "TabsList";
var TabsList = React.forwardRef(function (props, forwardedRef) {
  var __scopeTabs = props.__scopeTabs,
      _props$loop = props.loop,
      loop = _props$loop === void 0 ? true : _props$loop,
      listProps = _objectWithoutProperties(props, _excluded2);

  var context = useTabsContext(TAB_LIST_NAME, __scopeTabs);
  var rovingFocusGroupScope = useRovingFocusGroupScope(__scopeTabs);
  return /* @__PURE__ */jsx(RovingFocusGroup.Root, _objectSpread(_objectSpread({
    asChild: true
  }, rovingFocusGroupScope), {}, {
    orientation: context.orientation,
    dir: context.dir,
    loop: loop,
    children: /* @__PURE__ */jsx(Primitive.div, _objectSpread(_objectSpread({
      role: "tablist",
      "aria-orientation": context.orientation
    }, listProps), {}, {
      ref: forwardedRef
    }))
  }));
});
TabsList.displayName = TAB_LIST_NAME;
var TRIGGER_NAME = "TabsTrigger";
var TabsTrigger = React.forwardRef(function (props, forwardedRef) {
  var __scopeTabs = props.__scopeTabs,
      value = props.value,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      triggerProps = _objectWithoutProperties(props, _excluded3);

  var context = useTabsContext(TRIGGER_NAME, __scopeTabs);
  var rovingFocusGroupScope = useRovingFocusGroupScope(__scopeTabs);
  var triggerId = makeTriggerId(context.baseId, value);
  var contentId = makeContentId(context.baseId, value);
  var isSelected = value === context.value;
  return /* @__PURE__ */jsx(RovingFocusGroup.Item, _objectSpread(_objectSpread({
    asChild: true
  }, rovingFocusGroupScope), {}, {
    focusable: !disabled,
    active: isSelected,
    children: /* @__PURE__ */jsx(Primitive.button, _objectSpread(_objectSpread({
      type: "button",
      role: "tab",
      "aria-selected": isSelected,
      "aria-controls": contentId,
      "data-state": isSelected ? "active" : "inactive",
      "data-disabled": disabled ? "" : void 0,
      disabled: disabled,
      id: triggerId
    }, triggerProps), {}, {
      ref: forwardedRef,
      onMouseDown: composeEventHandlers(props.onMouseDown, function (event) {
        if (!disabled && event.button === 0 && event.ctrlKey === false) {
          context.onValueChange(value);
        } else {
          event.preventDefault();
        }
      }),
      onKeyDown: composeEventHandlers(props.onKeyDown, function (event) {
        if ([" ", "Enter"].includes(event.key)) context.onValueChange(value);
      }),
      onFocus: composeEventHandlers(props.onFocus, function () {
        var isAutomaticActivation = context.activationMode !== "manual";

        if (!isSelected && !disabled && isAutomaticActivation) {
          context.onValueChange(value);
        }
      })
    }))
  }));
});
TabsTrigger.displayName = TRIGGER_NAME;
var CONTENT_NAME = "TabsContent";
var TabsContent = React.forwardRef(function (props, forwardedRef) {
  var __scopeTabs = props.__scopeTabs,
      value = props.value,
      forceMount = props.forceMount,
      _children = props.children,
      contentProps = _objectWithoutProperties(props, _excluded4);

  var context = useTabsContext(CONTENT_NAME, __scopeTabs);
  var triggerId = makeTriggerId(context.baseId, value);
  var contentId = makeContentId(context.baseId, value);
  var isSelected = value === context.value;
  var isMountAnimationPreventedRef = React.useRef(isSelected);
  React.useEffect(function () {
    var rAF = requestAnimationFrame(function () {
      return isMountAnimationPreventedRef.current = false;
    });
    return function () {
      return cancelAnimationFrame(rAF);
    };
  }, []);
  return /* @__PURE__ */jsx(Presence, {
    present: forceMount || isSelected,
    children: function children(_ref) {
      var present = _ref.present;
      return /* @__PURE__ */jsx(Primitive.div, _objectSpread(_objectSpread({
        "data-state": isSelected ? "active" : "inactive",
        "data-orientation": context.orientation,
        role: "tabpanel",
        "aria-labelledby": triggerId,
        hidden: !present,
        id: contentId,
        tabIndex: 0
      }, contentProps), {}, {
        ref: forwardedRef,
        style: _objectSpread(_objectSpread({}, props.style), {}, {
          animationDuration: isMountAnimationPreventedRef.current ? "0s" : void 0
        }),
        children: present && _children
      }));
    }
  });
});
TabsContent.displayName = CONTENT_NAME;

function makeTriggerId(baseId, value) {
  return "".concat(baseId, "-trigger-").concat(value);
}

function makeContentId(baseId, value) {
  return "".concat(baseId, "-content-").concat(value);
}

var Root2 = Tabs;
var List = TabsList;
var Trigger = TabsTrigger;
var Content = TabsContent;
export { Content, List, Root2 as Root, Tabs, TabsContent, TabsList, TabsTrigger, Trigger, createTabsScope };